import React from "react";
import PropTypes from "prop-types";

import { routerShape } from "react-router/lib/PropTypes";
import withRouter from "react-router/lib/withRouter";
import { BreakPoints, PointStages } from '../../constants/AppConstants';
import t from "../../lib/I18n";
import FeatureFlagStore from '../../stores/FeatureFlagStore';
import connectToStores from "../../helpers/connectToStores";
import { smartCarnetSchema, daySaveSchema, roversRangersSchema } from "../../helpers/JPWidgetSchemas";
import PreviousSearchesStore from "../../stores/PreviousSearchesStore";
import SmartCarnetRecordSearch from "../../records/smartCarnet/SmartCarnetRecordSearch";
import DaySaveSearch from "../../records/DaySaveSearch";
import RoversRangersSearch from "../../records/RoversRangersSearch";

import urls from '../../urls';
import config from "../../config";
import MapComponent from "../Map";
import ResponsiveRender from "../ResponsiveRender";
import SearchLeftColumn from "../search/LeftColumn";
import SecretVersion from '../inApp/SecretVersion';
import JPWidget from "../widget/JPWidget";

function _getStateFromStores() {
    const previousSmartCarnetSearch = PreviousSearchesStore.get('smartCarnet');
    const previousDaySaveSearch = PreviousSearchesStore.get('daySave').refreshDates();
    const previousRoversSearch = PreviousSearchesStore.get('roversRangers').refreshDates();

    return {
        previousSmartCarnetSearch,
        previousDaySaveSearch,
        previousRoversSearch,
    };
}

@connectToStores([ PreviousSearchesStore ], _getStateFromStores)
@withRouter
class OtherSearch extends React.PureComponent {

    static propTypes = {
        router: routerShape,
        previousSmartCarnetSearch: PropTypes.instanceOf(SmartCarnetRecordSearch),
        previousDaySaveSearch: PropTypes.instanceOf(DaySaveSearch),
        previousRoversSearch: PropTypes.instanceOf(RoversRangersSearch),
    };

    performSearch = async (url) => {
        this.props.router.push(url);
    };

    componentDidMount () {
        if (!FeatureFlagStore.get('enableMap')) {
            this.props.router.push(urls.location(PointStages.SEARCH));
        }
    }

    render() {
        return (
            <div>
                <SearchLeftColumn title={ t('pageTitles.other-search') }>
                    <section className="booking__section other-ticket-options">
                        <JPWidget
                            params={{
                                brand: config.get('tocCode'),
                                apiUrl: `https://${config.get('apiHost')}`,
                                stylesheetUrl: config.get('jpWidgetStylesheetUrl'),
                                vertical: true,
                                activeTab: "OTHER",
                                hideNavigation: true,
                                disableBackground: true,
                                hidePromotionalText: true,
                                enableDaySave: FeatureFlagStore.get('enableDaySave') && !FeatureFlagStore.get('enableHiddenDaySave'),
                                enableRoversRangers: FeatureFlagStore.get('enableRoversRangers'),
                                enableSmartCarnet: FeatureFlagStore.get('enableSmartCarnet'),
                                disabledTabs: "",
                                enableKentRover: FeatureFlagStore.get('enableKentRover'),
                                searchCallBack: (url, data) => this.performSearch(url, data),
                                defaultValues: {
                                    ticketTypes: {
                                        ...smartCarnetSchema(this.props.previousSmartCarnetSearch),
                                        ...daySaveSchema(this.props.previousDaySaveSearch),
                                        ...roversRangersSchema(this.props.previousRoversSearch),
                                    }
                                }
                            }}
                        />
                        <SecretVersion />
                    </section>
                </SearchLeftColumn>

                <ResponsiveRender minWidth={ BreakPoints.TABLET_PORTRAIT_WIDTH }>
                    <MapComponent className={ 'map right-col' }/>
                </ResponsiveRender>
            </div>
        );
    }
}

export default OtherSearch;



// WEBPACK FOOTER //
// ./src/components/otherTicket/Search.js